import React, { useState, useEffect, useContext } from "react";
import { Outlet } from "react-router-dom";
import { UserContext } from "../../contexts/UserContext";
import UnifiedSidebar from "./UnifiedSidebar";
import RouteGuard from "../RouteGuard";
import HelpButton from "../HelpButton";
import PhoneBook from "../user/PhoneBook";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UnifiedLayout = () => {
  // The app navigation is always a 64px rail; it widens over the page only while somebody
  // hovers or clicks it (UnifiedSidebar) — user 2026-09-25. It used to start expanded, and a
  // visit to the dashboard, admin, users, profile or settings pinned it open for every page after.
  // Kept as state because screens still read it from the outlet context (HolidayCalendar) and
  // ask for it collapsed (Daily Report, Work Planning, the Resource Board's side panel).
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [showPhoneBook, setShowPhoneBook] = useState(false);
  const [viewMode, setViewMode] = useState('admin'); // 'admin' lub 'user' - dla przełączania widoku przez admina
  const { user } = useContext(UserContext);

  useEffect(() => {
    document.body.style.overflow = "auto";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div className="h-screen w-screen bg-slate-50 flex overflow-hidden">
      <UnifiedSidebar
        onOpenPhoneBook={() => setShowPhoneBook(true)}
        viewMode={viewMode}
        setViewMode={setViewMode}
      />
      <main className="flex-1 h-full overflow-y-auto">
        <RouteGuard>
          <Outlet context={{ sidebarCollapsed, setSidebarCollapsed, viewMode }} />
        </RouteGuard>
      </main>

      {/* Phone Book Modal */}
      <PhoneBook isOpen={showPhoneBook} onClose={() => setShowPhoneBook(false)} />

      <HelpButton />
      <ToastContainer position="top-center" autoClose={3000} />
    </div>
  );
};

export default UnifiedLayout;
